export default {
  apiGateway: {
    URL: 'https://muonzho0n6.execute-api.ap-northeast-1.amazonaws.com/prod/',
    URL_WWW: 'https://gllaoob9d7.execute-api.ap-northeast-1.amazonaws.com/prod/',
    REGION: 'ap-northeast-1',
  },
  cognito: {
    REGION: 'ap-northeast-1',
    IDENTITY_POOL_ID: 'ap-northeast-1:02b279df-a60b-4227-9c63-25f9b3ec12ab',
    USER_POOL_ID : 'ap-northeast-1_nMsPqpVbU',
    APP_CLIENT_ID : '7n6h6kekj1pq1q3pls82tifbb4',
  }
};



// WEBPACK FOOTER //
// ./src/config.js